import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconSize } from '@mylighthouse/prism-ember/types/components/prism/icon';
import type { Ota } from 'frontend-utils/models';
import type { OtaId } from 'frontend-utils/utils/constants/constant-values';
import type { PeriodParity, PeriodRate } from 'lumen/models/period';
import type {
  MealTypeValues,
  RateParam,
} from 'lumen/utils/constants/general-constants';
import getRateIcons from 'lumen/utils/rate-icons';

interface GeneralRateIconsSignature {
  Args: {
    leaveSpaceWhenEmpty?: boolean;
    mealPlan: MealTypeValues;
    otaId?: OtaId;
    rate: PeriodRate | PeriodParity | undefined;
    rateParam: RateParam;
    size?: IconSize;
  };
}

export default class GeneralRateIcons extends Component<GeneralRateIconsSignature> {
  @service declare store: Services['store'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get leaveSpaceWhenEmpty() {
    return this.args.leaveSpaceWhenEmpty && this.rateIcons.length === 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rateIcons() {
    let ota = null;

    if (this.args.otaId) {
      ota = this.store.peekRecord<Ota>('ota', this.args.otaId);
    }

    return getRateIcons(
      this.args.rate,
      this.args.rateParam,
      ota,
      this.args.mealPlan,
    );
  }

  <template>
    <div class="flex {{if this.leaveSpaceWhenEmpty 'ml-500' ''}}">
      {{#each this.rateIcons as |rateIcon|}}
        <div class={{if rateIcon "ml-100"}}>
          {{#if rateIcon}}
            <PrismIcon
              @name={{rateIcon}}
              @size={{if @size @size "extra-small"}}
            />
          {{/if}}
        </div>
      {{/each}}
    </div>
  </template>
}
